<template>
  <div>
    <b-alert
      :show="showDismissibleAlert"
      variant="error"
      dismissible
      @dismissed="showDismissibleAlert=false"
    >{{ msg }}
    </b-alert>
    <nav-bar
      v-show="inMeeting"
      :meeting-info="meetingInfo"
      fixed="top"/>
    <side-bar
      v-show="inMeeting"
      ref="sideBar" />
    <b-container
      :class="{ pushed: expanded, meeting: inMeeting}"
      fluid>
      <div
        v-show="connecting"
        class="text-center rounded connecting mx-auto">
        <div class="spinner-border text-primary m-4">
          <span class="sr-only">Loading...</span>
        </div>
        <div class="small">Connecting...</div>
      </div>

      <configure-devices
        ref="configDevices"/>
      <b-row
        v-show="inMeeting"
        class="overflow-hidden"
      >
        <div>
          <settings ref="settings"/>
        </div>
        <b-col class="mobileHeight">
          <desktop ref="shareDesktop"/>
          <video-area
            v-if="session"
            ref="videoArea"
            :mode="videoMode"
            :streams="localVideoStreams.concat(remoteVideoStreams)"
          />
        </b-col>
      </b-row>
    </b-container>
    <div
      fixed="bottom">
      <meeting-controls
        v-show="inMeeting"
        ref="meetingControls"
        :class="{ pushed: expanded }"
        :selected-video-layout = "videoMode"
        class="menuBar"
      />
    </div>
    <audio
      v-if="session"
      id="audio"
      :src-object.prop.camel="remoteAudioStream"
      autoplay="true"
      playsinline
    />
    <audio
      id="kevin"
      src="/static/sounds/kevin.mp3"
    />
    <audio
      id="test"
      src="/static/sounds/test.wav"
      preload="auto"/>
  </div>
</template>

<script>
import {randomId} from "../functions/globalMethods"
import {getBrowser, isSupported, isMobile, isIos, isSupportedShare} from "../functions/browserDetails"
import {isDebug, getItem, setItem, loadStorageData, removeChatItems, getMetaToken, saveMetaToken, removeMetaToken} from "../functions/storageManager"
import {ref, watch, onMounted, onBeforeUnmount} from "@vue/composition-api"
import ConfigureDevices from './ConfigureDevices'
import Desktop from './Desktop'
import MeetingControls from './MeetingControls'
import Participants from './Participants'
import Settings from './Settings'
import VideoArea from './VideoArea'
import NavBar from "./NavBar";
import SideBar from "./SideBar";
import LoadingIcon from "icons/Loading"

export default {
  name: 'StartMeeting',
  components: {
    'configure-devices': ConfigureDevices,
    'meeting-controls': MeetingControls,
    'desktop': Desktop,
    'participants': Participants,
    'settings': Settings,
    'video-area': VideoArea,
    'nav-bar': NavBar,
    'side-bar': SideBar,
    'loading-icon': LoadingIcon
  },
  setup(props, context) {
    const screenWidth = ref(screen.width)
    const msg = ref("")
    let expanded = ref(false)
    const showDismissibleAlert = ref(false)
    let browser = getBrowser()
    const remoteVideoNumber = ref(8)
    const maxBw = ref(0)
    const videoHeight = ref(0)
    const videoWidth = ref(0)
    const videoMode = ref(0)
    const animationFrame = ref("")
    const plenary = ref(false)
    const meetingData = ref({})
    const userName = ref('')
    const timer = ref({})
    const pandaWsInfo = ref({domain:"", id: ""})
    const meetingInvText = ref({})


    document.body.style.backgroundColor = "#141414";
    loadStorageData()
    if (getItem('videoMode') !== undefined) {
      videoMode.value = getItem('videoMode')
    }
    if (getItem('meetingData') !== undefined) {
      meetingData.value = getItem('meetingData')
    }

    if (!isSupported()) {
      if (!isIos()) {
        msg.value = context.root.$t("LOGIN.SPAN_NOSUPPORT") + 'Chrome / Firefox.'
      } else {
        msg.value = context.root.$t("LOGIN.SPAN_NOSUPPORT") + 'Safari.'
      }
      showDismissibleAlert.value = true
    }

    const webrtcPhone = ref({})
    const webrtcMeta = ref({})
    const meetingInfo = ref({})
    const localAudioStream = ref([])
    const localVideoStreams = ref([])
    const remoteAudioStream = ref({})
    const remoteVideoStreams = ref([])
    const session = ref({})
    const miceLevel = ref('')
    const prevMikeLevel = ref('0')
    const inMeeting = ref(false)
    const reconnecting = ref(false)
    const connecting = ref(false)
    const selectedCameraId = ref('')
    const selectedMicId = ref('')
    const selectedSinkId = ref('')
    const actualVideoDevice = ref({})
    const actualAudioDevice = ref({})
    const audioDevices = ref([])
    const audioOutputDevices = ref([])
    const videoDevices = ref([])
    const newChat = ref(0)
    const newSystemMessage = ref(0)
    const roomName = ref('')
    const metaUserInfo = ref({})
    const numberOfPeople = ref(0)
    const meta_token = ref('')
    const audioDom = ref ({});
    initialize()


    webrtcPhone.value.on('connected', (e) => {
      if (isDebug('info')) context.root.$notify.info('connected to: ' + e.socket.socket._url)
      if (reconnecting.value == true) {
        clearSessionTracks()
        if (Object.keys(webrtcPhone.value).length > 0) {
          webrtcPhone.value.stop()
          webrtcPhone.value = {}
          session.value = {}
        }
        setTimeout(() => window.location.reload(), 5000)
      } else {
        webrtcPhone.value.register()
      }
    })

    webrtcPhone.value.on('disconnected', (e) => {
      msg.value = context.root.$t("MEETING.ERROR_MESSAGE")
      if (e.message && e.message.reason_phrase) {
        msg.value += context.root.$t("LOGIN." + e.message.reason_phrase)
        showDismissibleAlert.value = true
      } else if (e.cause) {
        msg.value += e.cause
        showDismissibleAlert.value = true
      } else if (e.error.code === 1006) {
        if (inMeeting.value == true) {
          context.root.$notify('reconnecting')
          reconnecting.value = true
        } else {
          context.root.$notify('reconnecting')
        }
      } else {
        reconnecting.value = false
        showDismissibleAlert.value = true
      }
    })

    webrtcPhone.value.on('registered', (e) => {
      if (isDebug('info')) context.root.$notify.info('register as: ' + e.response.from._uri)
      reconnecting.value = false
      context.refs.configDevices.configureDevices()
    })

    webrtcPhone.value.on('newMessage', (e) => {
      if (e.request.headers['Vibe-Plenary']) {
        context.refs.meetingControls.$refs.handr.messageHandler(e.request.headers['Vibe-Plenary'][0].raw)
      } else if (e.request.headers['Cnv-Conn']) {
        let wsInfo = e.request.headers['Cnv-Conn'][0].raw
        pandaWsInfo.value.domain = wsInfo.split('/')[0].replace(/\./g, "-") + "-meta.corenexa.com"
        pandaWsInfo.value.id = wsInfo.split('/')[1]
        initializePandaWebsocket()
      } else if (e.request.headers['Vibe-Bandwidth']) {
        maxBw.value = e.request.headers['Vibe-Bandwidth'][0].raw
        if (maxBw.value > 0) {
          setMaxBw(maxBw.value)
        }
      }
      else {
        messageHandler(e)
      }
    })

    webrtcPhone.value.on('newRTCSession', (e) => {
      session.value = e.session
      e.session.connection.addTransceiver('audio', {direction: 'sendrecv'})

      if (remoteVideoNumber.value > 0) {
        e.session.connection.addTransceiver('video', {direction: 'sendrecv'})
        e.session.connection.addTransceiver('video', {direction: 'sendrecv'})
        if (remoteVideoNumber.value > 2) {
          for (let i = 2; i < remoteVideoNumber.value; i++) {
            e.session.connection.addTransceiver('video', {direction: 'recvonly'})
          }
        }
      }

      /* let sendChannel = e.session.connection.createDataChannel('sendDataChannel', { negotiated: true, id: 1 })

      sendChannel.onopen = () => { console.log('data channel open') }
      sendChannel.onclose = () => { console.log('data channel close') } */

      e.session.connection.onconnectionstatechange = event => {
        if (session.value.connection.connectionState === "failed" || session.value.connection.connectionState === "disconnected") {
         console.log('Session Connection Changed to Bad State', session.value.connection.connectionState);
        }
      }

      e.session.connection.oniceconnectionstatechange = event => {
        if (session.value.connection.iceConnectionState === "failed" || session.value.connection.iceConnectionState === "closed") {
          console.log('ICE Connection Changed to Bad State', session.value.connection.iceConnectionState);
        }
      }

      e.session.connection.ontrack = event => {
        if (event.transceiver.receiver.track && event.transceiver.receiver.track.kind === 'audio') {
          event.transceiver.receiver.track.enabled = true
          remoteAudioStream.value = new MediaStream([event.transceiver.receiver.track])
        }
        if (event.transceiver.sender.track && event.transceiver.sender.track.kind === 'audio') {
          event.transceiver.sender.track.enabled = context.refs.configDevices.miceOn
          localAudioStream.value.push({
            media: new MediaStream([event.transceiver.sender.track]),
            source: "mic",
            mid: event.transceiver.mid
          })
        }
        if (event.transceiver.receiver.track && event.transceiver.receiver.track.kind === 'video' && (event.transceiver.direction === 'sendrecv' || event.transceiver.direction === 'recvonly')) {
          if (event.transceiver.direction === 'sendrecv') {
            if (event.transceiver.sender.track) {
              event.transceiver.sender.track.enabled = true
              localVideoStreams.value.push({
                media: new MediaStream([event.transceiver.sender.track]),
                active: false,
                loaded: true,
                source: 'camera',
                clicked: false,
                mid: event.transceiver.mid,
                local: true,
                user: {}
              })
            } else {
              localVideoStreams.value.push({
                media: new MediaStream(),
                source: 'desktop',
                clicked: false,
                mid: event.transceiver.mid,
                local: true,
                user: {},
              })
            }
          }
          remoteVideoStreams.value.push({
            media: new MediaStream([event.transceiver.receiver.track]),
            active: false,
            loaded: false,
            clicked: false,
            packetsLostPerc: 0,
            packetsLost: 0,
            packetsRecv: 0,
            ssrc: '',
            bytesRecv: 0,
            user: {
              id: null,
              firstName: '',
              lastName: '',
              isMuted: false,
              videoOff: false,
              title: '',
            },
          })
        }
      }
      e.session.on('getusermediafailed', () => {
        if (isDebug('info')) context.root.$notify.info('Access to the audio/video device failed.')
      })
      e.session.on('connecting', (e) => {
        if (isDebug('info')) context.root.$notify.info('connecting to: ' + e.request.to.uri)
      })
      e.session.on('sdp', (e) => {
        if (isDebug('info')) context.root.$notify.info('SDP created')
      })
      e.session.on('sending', (e) => {
        if (isDebug('info')) context.root.$notify.info('Sending')
      })
      e.session.on('accepted', (e) => {
        document.title = 'webRTC - ' + e.response.headers['X-Seevogh-Title'][0].raw
        roomName.value = e.response.headers['X-Seevogh-Title'][0].raw;
        let meetingType = e.response.headers['X-Seevogh-Meetingtype'][0].raw
        context.refs.meetingControls.meetingOptions = e.response.headers['X-Seevogh-Meetingoptions'][0].raw
        switch (meetingType) {
          case 'Plenary Session':
          case 'Classroom':
            context.refs.meetingControls.plenarySession(true)
            if (localAudioStream.value.length > 0 && context.refs.configDevices.miceOn) {
              localAudioStream.value[0].media.getAudioTracks()[0].enabled = false
            }
            if (localVideoStreams.value.length > 0 && context.refs.configDevices.cameraOn) {
              sendStillImage()
            }
            plenary.value = true
            break
          case 'Broadcast':
            context.refs.meetingControls.broadcast()
            break
          default:
            context.refs.meetingControls.handControls = false
        }
        if (isDebug('info')) context.root.$notify.info('Call is accepted')
      })
      e.session.on('confirmed', (e) => {
        //context.refs.remoteInfoRef.style.display = 'block'
        context.root.$notify.info(context.root.$t("MEETING.SUCCESS_MESSAGE"))
        connecting.value = false
        context.refs.meetingControls.setMeetingOptions()
        if(!context.refs.configDevices.cameraOn) {
          context.refs.meetingControls.sendControlUpdate(context.refs.configDevices.cameraOn, 'camera')
        }
        if(!context.refs.configDevices.miceOn) {
          context.refs.meetingControls.sendControlUpdate(context.refs.configDevices.miceOn, 'mic')
        }
        inMeeting.value = true
      })
      e.session.on('ended', (e) => {
        msg.value = context.root.$t("MEETING.ERROR_MESSAGE")
        if (e.message && e.message.headers['X-Bye-Reason']) {
          msg.value += context.root.$t("LOGIN." + e.message.headers['X-Bye-Reason'][0].raw)
          showDismissibleAlert.value = true
        } else if (e.message && e.message.reason_phrase) {
          msg.value += context.root.$t("LOGIN." + e.message.reason_phrase)
        } else {
          msg.value += e.cause
        }
        connecting.value = false
        showDismissibleAlert.value = true
      })
      e.session.on('failed', (e) => {
        msg.value = context.root.$t("MEETING.ERROR_MESSAGE")
        if (e.cause === 'Bad Media Description') {
          msg.value += context.root.$t("LOGIN." + e.message.reason_phrase)
          connecting.value = false
          showDismissibleAlert.value = true
        } else if (e.message && e.message.reason_phrase) {
          msg.value += context.root.$t("LOGIN." + e.message.reason_phrase)
          connecting.value = false
          showDismissibleAlert.value = true
        } else {
          if (e.cause === window.JsSIP.C.causes.USER_DENIED_MEDIA_ACCESS) {
            msg.value += 'Please select different audio or video device or allow access to the media when prompted.'
          } else {
            msg.value += e.cause
          }
          connecting.value = false
          showDismissibleAlert.value = true
        }
      })
    })

    //webrtcPhone.value.start()

    onMounted(() => {
      context.root.$nextTick(function () {
        window.addEventListener('unload', exitMeeting)
      })
    })

    onBeforeUnmount(() => {
      window.removeEventListener('unload', exitMeeting)
      clearSessionTracks()
      if (Object.keys(webrtcPhone.value).length > 0) {
        webrtcPhone.value.stop()
        webrtcPhone.value = {}
      }
      removeChatItems()
      document.title = 'webRTC'
      webrtcMeta.value.send(JSON.stringify({
        d_type: "WSLogout"
      }))
    })

    function initialize() {

      let socket = []
      process.env.webSockets.forEach(value => {  //websockets comes from webpack definePlugins
        socket.push(new window.JsSIP.WebSocketInterface(value))
        socket[socket.length - 1].via_transport = 'wss'
      })

      let domain = ""
      domain = process.env.webSocketDomain;
      let name = context.root.$route.query.name ? context.root.$route.query.name : meetingData.value.name
      userName.value = name;
      let sipName = name.replace(/\W/g, '') + '_' + randomId()
      let configuration = {
        sockets: socket,
        uri: 'sip:' + sipName + '@' + domain,
        display_name: encodeURIComponent(name),
        register: true,
        session_timers: false,
        user_agent: "JsSIP 3.3.9 - webrtc client " + window.version.ui,
        connection_recovery_min_interval: 10,
        connection_recovery_max_interval: 120
      }
      webrtcPhone.value = new window.JsSIP.UA(configuration)
      webrtcPhone.value.start()

      meta_token.value = context.root.$route.query.r ? context.root.$route.query.r : getMetaToken()
      if(meta_token.value) {
        let href = window.location.href
        window.location.href = href.replace(`r=${meta_token.value}`, "")
        saveMetaToken(meta_token.value)
      }
    }

    function initializePandaWebsocket() {
      let metaUrl = `wss://${pandaWsInfo.value.domain}:36030/websocket`
      webrtcMeta.value = new WebSocket(metaUrl);

      webrtcMeta.value.onopen = function (event) {
        console.log('meta socket successfully connected')
        logIntoWebSocket()
      };

      webrtcMeta.value.onerror = function (event) {
        if (event.type === 'error') {
          removeMetaToken()
          context.root.$notify.error('Something went wrong trying to log you in, some meeting features may be unavailable')
        }
      };
      webrtcMeta.value.onmessage = function (event) {
        let message = JSON.parse(event.data);
        switch (message.d_type) {
          case "WSLogin":
            metaUserInfo.value = message.user;
            break;
          case "WSRequest":
            processRequest(message);
            break;
          case "WSPresence":
            context.refs.sideBar.$refs.sidePart.processPresense(message)
            break;
          case "WSParticipant":
            context.refs.sideBar.$refs.sidePart.processParticipant(message)
            break;
          case "WSMeeting":
            if(message.vibeID === meetingData.value.meetingID || message.options.includes("[alias=" + meetingData.value.meetingID + "]")){
              message.accessPin = '' // Remove when data is live
              message.dialIn = ''// Remove when data is live
              meetingInfo.value = message
            }
            break;
          case "WSMeetingText":
            meetingInvText.value = message
            break;
          case "WSKick":
            context.root.$notify.info("A Moderator kicked you from the meeting.")
            exitMeeting()
            break;
          case "WSSpeaker":
            console.log("WSSpeaker: " + message.current.toString());
            context.refs.videoArea.messageHandler(message.current.toString())
            break;
          case "WSMute":
            if (message.audio == false) {
              context.refs.meetingControls.mic = false
              context.root.$notify.info('A Moderator has turned off your microphone.')
            } else if (message.video == false) {
              context.refs.meetingControls.camera = false
              context.root.$notify.info('A Moderator has turned off your camera.')
            }
            break;
          case "WSUserIcon":
            //TODO Avatars coming in as byteArray;
            break;
        }
      }
    }

    function processRequest(request) {
      switch (request.askFor){
        case "presence":
          webrtcMeta.value.send(JSON.stringify({
            d_type: "WSPresence",
            ID: request.ID,
            user: metaUserInfo.value,
            status: 'In Meeting',
            isAudioOn: context.refs.meetingControls.mic,
            isVideoOn: context.refs.meetingControls.camera,
          }))
          break;
      }
    }

    function askMeetingInvText() {
      if (Object.keys(meetingInvText.value).length < 1 ||
        meetingInvText.value.lang != context.root.$i18n.locale ||
        meetingInvText.value.mid != meetingInfo.value.vibeID) {
        webrtcMeta.value.send(JSON.stringify({
          d_type: "WSMeetingText",
          mid: meetingInfo.value.vibeID,
          lang: context.root.$i18n.locale
        }))
      }
    }

    function logIntoWebSocket() {
      let externalID = pandaWsInfo.value.id;
      if(meta_token.value) {
        webrtcMeta.value.send(JSON.stringify({
          d_type: "WSLoginJWT",
          jwt: meta_token.value,
          meetingID: context.root.$route.query.meetingID ? context.root.$route.query.meetingID : meetingData.value.meetingID,
          extUserID: externalID
        }))
      } else {
        webrtcMeta.value.send(JSON.stringify({
          d_type: "WSLoginGuest",
          meetingID: context.root.$route.query.meetingID ? context.root.$route.query.meetingID : meetingData.value.meetingID,
          nickname: context.root.$route.query.name ? context.root.$route.query.name : meetingData.value.name,
          extUserID: externalID
        }))
      }
    }



    function setMaxBw(value) {
      console.log('bandwidth changed: ' + value)
      session.value.connection.getTransceivers().forEach(transceiver => {
        if (transceiver.sender && transceiver.sender.track && transceiver.sender.track.kind == 'video') {
          const parameters = transceiver.sender.getParameters()
          if (!parameters.encodings) {
            parameters.encodings = [{}]
          }
          if (context.refs.meetingControls.desktop) {
            parameters.encodings[0].maxBitrate = value / 2
            parameters.encodings[0].networkPriority = "high"
            parameters.encodings[0].priority = "high"
          } else {
            parameters.encodings[0].maxBitrate = value
            parameters.encodings[0].networkPriority = "high"
            parameters.encodings[0].priority = "high"
          }
          transceiver.sender.setParameters(parameters)
        }
      })
    }

    async function sendStillImage() {
      let index = localVideoStreams.value.findIndex(sender => sender.source == 'camera')
      localVideoStreams.value[index].media.getTracks().forEach(track => {
        track.stop()
        localVideoStreams.value[index].media.removeTrack(track)
      })
      let imageMedia = context.refs.configDevices.captureImage()
      imageMedia.getTracks()[0].enabled = true

      let videoTrans = session.value.connection.getTransceivers().find(trans => trans.mid == localVideoStreams.value[index].mid)
      await videoTrans.sender.replaceTrack(imageMedia.getTracks()[0]).catch(e => console.log(e))
      localVideoStreams.value[index].media = imageMedia
      localVideoStreams.value[index].active = false
    }

    async function changeDevice(device, kind, forceRestream) {
      if (kind === 'video') {
        actualVideoDevice.value = device
        if (!context.refs.meetingControls.camera) {
          selectedCameraId.value = device.deviceId
          context.refs.meetingControls.$refs.meetingSettings.$emit('close')
          if(!forceRestream) {
            return
          }
        }
      } else if (kind === 'audio') {
        actualAudioDevice.value = device
        if (!context.refs.meetingControls.mic) {
          selectedMicId.value = device.deviceId
          context.refs.meetingControls.$refs.meetingSettings.$emit('close')
          if(!forceRestream) {
            return
          }
        }
      }
      let constraints = {audio: false, video: false}
      let index = localVideoStreams.value.findIndex(sender => sender.source == 'camera')
      if (kind === 'video') {
        context.refs.configDevices.video_constraints.deviceId.exact = device.deviceId
        selectedCameraId.value = device.deviceId
        if (!browser.safari) {
          setItem('cameraId', selectedCameraId.value)
        }
        constraints = {
          audio: false,
          video: context.refs.configDevices.video_constraints
        }
        localVideoStreams.value[index].media.getTracks().forEach(track => {
          track.stop()
          localVideoStreams.value[index].media.removeTrack(track)
        })
      } else if (kind === 'audio') {
        context.refs.configDevices.audio_constraints.deviceId.exact = device.deviceId
        selectedMicId.value = device.deviceId
        if (!browser.safari) {
          setItem('miceId', selectedMicId.value)
        }
        constraints = {
          audio: context.refs.configDevices.audio_constraints,
          video: false
        }
        localAudioStream.value[0].media.getTracks().forEach(track => {
          track.stop()
          localAudioStream.value[0].media.removeTrack(track)
        })
      }
      let mediaStream = await navigator.mediaDevices.getUserMedia(constraints).catch((error) => {
        context.root.$notify.error('Access to the media failed:' + error)
      })
      if (mediaStream) {
        if (kind === 'audio') {
          mediaStream.getAudioTracks()[0].enabled = context.refs.meetingControls.mic
          let audioTrans = session.value.connection.getTransceivers().find(trans => trans.mid == localAudioStream.value[0].mid)
          await audioTrans.sender.replaceTrack(mediaStream.getAudioTracks()[0]).catch(e => console.log(e))
          audioTrans.sender.track.enabled = context.refs.meetingControls.mic
          localAudioStream.value[0].media = mediaStream
        } else if (kind === 'video') {
          mediaStream.getVideoTracks()[0].enabled = true
          let videoTrans = session.value.connection.getTransceivers().find(trans => trans.mid == localVideoStreams.value[index].mid)
          await videoTrans.sender.replaceTrack(mediaStream.getVideoTracks()[0]).catch(e => console.log(e))
          localVideoStreams.value[index].media = mediaStream
          localVideoStreams.value[index].active = true
        }
      } else if (context.refs.meetingControls.camera == true && kind === 'video') {
        context.refs.meetingControls.camera = false
      } else if (context.refs.meetingControls.mic == true && kind === 'audio') {
        context.refs.meetingControls.mic = false
      }
      context.refs.meetingControls.$refs.meetingSettings.$emit('close')
    }

    function joinMeeting() {
      context.refs.configDevices.visible = false
      connecting.value = true
      let optionsSip = {
        pcConfig: window['webrtc-config'].turn,
        rtcConstraints: window['webrtc-config'].rtcConstraints,
        extraHeaders: ['X-SWEBRTC: server=SeeVogh;allstreams=true;websocket=true'],
        mediaStream: context.refs.configDevices.media
      }
      let destination
      if (context.root.$route.query.meetingID) {
        if (context.root.$route.query.pin) {
          destination = (context.root.$route.query.meetingID + context.root.$route.query.pin)
        } else {
          destination = context.root.$route.query.meetingID
        }
      } else if (meetingData.value.meetingID) {
        if (meetingData.value.pin) {
          destination = (meetingData.value.meetingID + meetingData.value.pin)
        } else {
          destination = meetingData.value.meetingID
        }
      } else {
        msg.value = context.root.$t("MEETING.ERROR_MESSAGE")
        msg.value += context.root.$t("LOGIN.WRONG_ID_OR_PIN")
        connecting.value = false
        showDismissibleAlert.value = true
      }
      //document.body.style.backgroundColor = "#0000000d"
      let href = window.location.href
      window.location.href = href.replace("directly=false", "directly=true")
      webrtcPhone.value.call(destination, optionsSip)
      audioDom.value = document.getElementById('audio');
      if(typeof getItem('sinkId') !== 'undefined' && browser.chrome) {
        let device = audioOutputDevices.value.find(device => device.deviceId === getItem('sinkId'))
        if(device) {
          audioDom.value.setSinkId(device.deviceId)
          selectedSinkId.value = device.deviceId;
        } else {
          console.log('Output device no longer available going to default');
          audioDom.value.setSinkId('default');
          selectedSinkId.value = 'default'
        }
      } else{
        selectedSinkId.value = 'default';
      }
    }

    async function sendAudioLevel() {
      if (inMeeting.value && localAudioStream.value.length > 0 && localAudioStream.value[0].media.getAudioTracks()[0] != null) {
        let audio_ssrc = ''
        let level = context.refs.meetingControls.$refs.miceVolume.getMikeLevel()
        if (prevMikeLevel.value > 0 || level > 0) {
          let result = await session.value.connection.getStats(localAudioStream.value[0].media.getAudioTracks()[0]).catch(e => console.log(e))
          result.forEach(report => {
            if (report.type === 'outbound-rtp') {
              audio_ssrc = report.ssrc
            }
          })
          miceLevel.value = level + '%'
          if (webrtcMeta.value.readyState === WebSocket.OPEN) {
            webrtcMeta.value.send(JSON.stringify({
              d_type: "WSAudioLevel",
              ssrc: audio_ssrc,
              level: +(level.toFixed(0)),
            }))
          } else {
            let options = {
              'extraHeaders': ['Vibe-AudioLevel: ' + level.toFixed(1) + ' ' + audio_ssrc]
            }
            let sipAdress
            if (context.root.$route.query.meetingID) {
              if (context.root.$route.query.pin) {
                sipAdress = (context.root.$route.query.meetingID + context.root.$route.query.pin)
              } else {
                sipAdress = context.root.$route.query.meetingID
              }
            } else if (meetingData.value.meetingID) {
              if (meetingData.value.pin) {
                sipAdress = (meetingData.value.meetingID + meetingData.value.pin)
              } else {
                sipAdress = meetingData.value.meetingID
              }
            }
            webrtcPhone.value.sendMessage(sipAdress, '', options)
          }
        }
        prevMikeLevel.value = level
      }
    }

    async function beforeJoinMeeting() {
      if (context.refs.configDevices.cameraOn == false) {
        await context.refs.configDevices.selectImage().catch(e => console.log(e))
      }
      context.refs.configDevices.removeTracks(context.refs.configDevices.audioMedia)
      if (context.refs.configDevices.$refs.testVideo) {
          context.refs.configDevices.$refs.testVideo.srcObject = null
      }
      joinMeeting()
    }

    function clearSessionTracks() {
      if (localVideoStreams.value) {
        localVideoStreams.value.forEach(stream => stream.media.getTracks().forEach((track) => {
          track.stop();
          stream.media.removeTrack(track)
        }))
      }
      if (localAudioStream.value) {
        localAudioStream.value.forEach(stream => stream.media.getTracks().forEach((track) => {
          track.stop();
          stream.media.removeTrack(track)
        }))
      }
      if (remoteAudioStream.value && typeof remoteAudioStream.value.getTracks === "function") {
        remoteAudioStream.value.getTracks().forEach((track) => {
          track.stop();
          remoteAudioStream.value.removeTrack(track)
        })
      }
      if (remoteVideoStreams.value) {
        remoteVideoStreams.value.forEach(stream => stream.media.getTracks().forEach((track) => {
          track.stop();
          stream.media.removeTrack(track)
        }))
      }
      context.refs.configDevices.removeTracks(context.refs.configDevices.media)
      context.refs.configDevices.removeTracks(context.refs.configDevices.audioMedia)
    }

    function messageHandler(e) {
      if (e.originator === 'remote' && e.request) {
        let message = e.request.body
        if (message === ""){
          return
        }
        var messageObject = JSON.parse(message);
        messageObject.IMMsg.replace(/href/g, "target='_blank'")
        if (messageObject.srcIM.lastName === '[Inbound WebRTC]') {
          if (messageObject.srcIM.firstName === userName.value )
            messageObject.self = true
          messageObject.srcIM.lastName = messageObject.srcIM.lastName.replace('[Inbound WebRTC]', '')
        }
        if(messageObject.systemMsg) {
          context.refs.sideBar.$refs.sideSystem.processMessage(messageObject)
        } else {
          console.log(messageObject)
        context.refs.sideBar.$refs.sideChat.processMessage(messageObject)
      }
    }
  }

    function exitMeeting() {
      clearSessionTracks()
      cancelAnimationFrame(animationFrame.value)
      if (Object.keys(webrtcPhone.value).length > 0) {
        webrtcPhone.value.stop()
        webrtcPhone.value = {}
        session.value = {}
      }
      //document.body.style.backgroundColor = "#ffffff"
      if (context.root.$route.query) {
        if (context.root.$route.query.branding) {
          context.root.$router.push({path: '/', query: {branding: context.root.$route.query.branding}})
          return
        }
      }
      context.root.$router.push('/')
      if (isIos()) {
        window.location.reload()
      }
    }

    return {
      screenWidth,
      webrtcPhone,
      msg,
      showDismissibleAlert,
      browser,
      getBrowser,
      isSupported,
      isSupportedShare,
      isMobile,
      isIos,
      getItem,
      setItem,
      removeChatItems,
      remoteVideoNumber,
      remoteVideoStreams,
      remoteAudioStream,
      localAudioStream,
      localVideoStreams,
      actualVideoDevice,
      actualAudioDevice,
      connecting,
      expanded,
      session,
      audioDevices,
      videoDevices,
      audioOutputDevices,
      joinMeeting,
      beforeJoinMeeting,
      exitMeeting,
      changeDevice,
      sendStillImage,
      selectedCameraId,
      selectedMicId,
      selectedSinkId,
      inMeeting,
      videoHeight,
      videoWidth,
      maxBw,
      setMaxBw,
      videoMode,
      miceLevel,
      prevMikeLevel,
      sendAudioLevel,
      reconnecting,
      animationFrame,
      plenary,
      meetingData,
      meetingInvText,
      askMeetingInvText,
      initialize,
      //sentMessages
      userName,
      newChat,
      timer,
      roomName,
      newSystemMessage,
      meetingInfo,
      audioDom,
      numberOfPeople,
      metaUserInfo,
      pandaWsInfo
    }
  }
}
</script>
<style scoped>
  .pushed{ width:calc(100% - 370px)!important; margin-left: 370px!important;}
  .spinner-border{
    width: 3rem;
    height: 3rem;
  }
  .connecting{
    background: #272727;
    max-width: 500px;
    padding: 40px;
    margin-top: 80px;
  }
  .small{
    color: #bbbbbb;
  }
  .mobileHeight{
    padding: 13px;
  }
  .container-fluid.meeting{
    width: calc(100% - 48px);
    margin-top: 42px;
  }
  @media (min-width: 768px) {
    .container-fluid.meeting{
      margin-left: 48px;
      display: inherit;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/StartMeeting.vue